/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MatrixCarePatient } from './MatrixCarePatient';
import {
    MatrixCarePatientFromJSON,
    MatrixCarePatientFromJSONTyped,
    MatrixCarePatientToJSON,
} from './MatrixCarePatient';

/**
 * 
 * @export
 * @interface CreateMatrixCarePatient201ResponseData
 */
export interface CreateMatrixCarePatient201ResponseData {
    /**
     * Indicates if a duplicate resident was detected in MatrixCare
     * @type {boolean}
     * @memberof CreateMatrixCarePatient201ResponseData
     */
    isDuplicatePatientError?: boolean;
    /**
     * Indicates that a duplicate was found and SSN is required to proceed with document upload
     * @type {boolean}
     * @memberof CreateMatrixCarePatient201ResponseData
     */
    requiresSsnForDuplicate?: boolean;
    /**
     * 
     * @type {MatrixCarePatient}
     * @memberof CreateMatrixCarePatient201ResponseData
     */
    record?: MatrixCarePatient;
}

/**
 * Check if a given object implements the CreateMatrixCarePatient201ResponseData interface.
 */
export function instanceOfCreateMatrixCarePatient201ResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateMatrixCarePatient201ResponseDataFromJSON(json: any): CreateMatrixCarePatient201ResponseData {
    return CreateMatrixCarePatient201ResponseDataFromJSONTyped(json, false);
}

export function CreateMatrixCarePatient201ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMatrixCarePatient201ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isDuplicatePatientError': !exists(json, 'isDuplicatePatientError') ? undefined : json['isDuplicatePatientError'],
        'requiresSsnForDuplicate': !exists(json, 'requiresSsnForDuplicate') ? undefined : json['requiresSsnForDuplicate'],
        'record': !exists(json, 'record') ? undefined : MatrixCarePatientFromJSON(json['record']),
    };
}

export function CreateMatrixCarePatient201ResponseDataToJSON(value?: CreateMatrixCarePatient201ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isDuplicatePatientError': value.isDuplicatePatientError,
        'requiresSsnForDuplicate': value.requiresSsnForDuplicate,
        'record': MatrixCarePatientToJSON(value.record),
    };
}

